import { render, staticRenderFns } from "./matrixSpread.vue?vue&type=template&id=6e9391d2&scoped=true"
import script from "./matrixSpread.vue?vue&type=script&lang=js"
export * from "./matrixSpread.vue?vue&type=script&lang=js"
import style0 from "./matrixSpread.vue?vue&type=style&index=0&id=6e9391d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9391d2",
  null
  
)

export default component.exports